// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weekNumberCalenderComponent {
  background-color: white;
  width: 93%;
  border-radius: 16px;
  margin: auto;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
}
.weekNumberCalenderComponent .table {
  border-collapse: collapse;
  border-spacing: 0;
  border-radius: 16px;
  margin: auto;
  width: 100%;
  position: relative !important;
  z-index: 1;
}
.weekNumberCalenderComponent .weekNumberHeader {
  background-color: white;
  min-width: 40px;
  height: 56px;
  border: none;
  text-align: left;
  padding-top: 33px;
  padding-left: 6px;
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
  align-items: center;
  text-transform: uppercase;
  color: #999999;
  border-top-right-radius: 16px;
}
.weekNumberCalenderComponent .weekNumberHeaderTitle {
  background-color: white;
  border-top-left-radius: 16px;
  min-width: 208px;
  height: 56px;
  border: none;
  text-align: left;
  padding-top: 33px;
  padding-left: 6px;
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
  align-items: center;
  text-transform: uppercase;
  color: #999999;
  border-right: 1px solid #e9e9e9;
}
.weekNumberCalenderComponent .columnHeaders {
  padding: 24px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #505054;
  border-top: 1px solid #e9e9e9;
  position: relative;
  width: 300px;
  bottom: 1px;
}
.weekNumberCalenderComponent .columnHeadersSpecials {
  color: #bd1823;
}
.weekNumberCalenderComponent .normalCell {
  border: 1px solid #e9e9e9;
  width: 4%;
  max-width: 48px;
}
.weekNumberCalenderComponent .dataContainer {
  height: 40px;
  border-radius: 8px;
  z-index: 10;
  padding: 11px 0 11px 8px;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  align-items: center;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  position: relative !important;
  margin-top: 3px;
  margin-bottom: 3px;
}
.weekNumberCalenderComponent .userList {
  position: relative;
  top: 2px;
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
  flex-direction: row-reverse;
}
.weekNumberCalenderComponent .userList .avatarImage {
  width: 24px;
  height: 24px;
  border-radius: 22px;
  position: relative;
  border: 1px solid #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/screens/calendarNote/weekNumberCalender/weekNumberCalender.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,UAAA;EACA,mBAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;AACJ;AAAI;EACI,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EAEA,WAAA;EACA,6BAAA;EACA,UAAA;AACR;AAEI;EACI,uBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,6BAAA;AAAR;AAEI;EACI,uBAAA;EACA,4BAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,+BAAA;AAAR;AAEI;EACI,aAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,6BAAA;EAEA,kBAAA;EACA,YAAA;EACA,WAAA;AADR;AAII;EACI,cAAA;AAFR;AAII;EACI,yBAAA;EACA,SAAA;EACA,eAAA;AAFR;AAKI;EACI,YAAA;EACA,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;AAHR;AAMI;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,2BAAA;AAJR;AAMQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAJZ","sourcesContent":[".weekNumberCalenderComponent {\n    background-color: white;\n    width: 93%;\n    border-radius: 16px;\n    margin: auto;\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal; \n    .table {\n        border-collapse: collapse;\n        border-spacing: 0;\n        border-radius: 16px;\n        margin: auto;\n        // table-layout: fixed;\n        width: 100%;\n        position: relative !important;\n        z-index: 1; \n    }\n\n    .weekNumberHeader {\n        background-color: white;\n        min-width: 40px;\n        height: 56px;\n        border: none;\n        text-align: left;\n        padding-top: 33px;\n        padding-left: 6px;\n        font-weight: 500;\n        font-size: 10px;\n        line-height: 16px;\n        align-items: center;\n        text-transform: uppercase;\n        color: #999999;\n        border-top-right-radius: 16px;\n    }\n    .weekNumberHeaderTitle {\n        background-color: white;\n        border-top-left-radius: 16px;\n        min-width: 208px;\n        height: 56px;\n        border: none;\n        text-align: left;\n        padding-top: 33px;\n        padding-left: 6px;\n        font-weight: 500;\n        font-size: 10px;\n        line-height: 16px;\n        align-items: center;\n        text-transform: uppercase;\n        color: #999999;\n        border-right: 1px solid #e9e9e9; \n    }\n    .columnHeaders {\n        padding: 24px;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 20px;\n        display: flex;\n        align-items: center;\n        color: #505054;\n        border-top: 1px solid #e9e9e9;\n        // border-left: 1px solid #e9e9e9;\n        position: relative;\n        width: 300px;  \n        bottom: 1px;\n    }\n\n    .columnHeadersSpecials {\n        color: #bd1823;\n    }\n    .normalCell {\n        border: 1px solid #e9e9e9;\n        width: 4%;\n        max-width: 48px;\n    }\n\n    .dataContainer {\n        height: 40px;\n        border-radius: 8px;\n        z-index: 10;\n        padding: 11px 0 11px 8px;\n        font-weight: 700;\n        font-size: 12px;\n        line-height: 18px;\n        align-items: center;\n        color: #ffffff;\n        display: flex;\n        justify-content: space-between;\n        position: relative !important;\n        margin-top: 3px;\n        margin-bottom: 3px;\n    }\n\n    .userList {\n        position: relative;\n        top: 2px;\n        margin-left: auto;\n        display: flex;\n        justify-content: flex-end;\n        margin-right: 10px;\n        flex-direction: row-reverse;\n\n        .avatarImage {\n            width: 24px;\n            height: 24px;\n            border-radius: 22px;\n            position: relative;\n            border: 1px solid #ffffff;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
